export default "__VITE_ASSET__12aeff0d__"